var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8C5.21666 8 4.979 7.90433 4.787 7.713C4.59566 7.521 4.5 7.28333 4.5 7C4.5 6.71667 4.59566 6.479 4.787 6.287C4.979 6.09567 5.21666 6 5.5 6H19.5C19.7833 6 20.0207 6.09567 20.212 6.287C20.404 6.479 20.5 6.71667 20.5 7C20.5 7.28333 20.404 7.521 20.212 7.713C20.0207 7.90433 19.7833 8 19.5 8H5.5ZM5.5 22C5.21666 22 4.979 21.904 4.787 21.712C4.59566 21.5207 4.5 21.2833 4.5 21V16H4.325C4.00833 16 3.75 15.879 3.55 15.637C3.35 15.3957 3.28333 15.1167 3.35 14.8L4.35 9.8C4.4 9.56667 4.51666 9.375 4.7 9.225C4.88333 9.075 5.09166 9 5.325 9H19.675C19.9083 9 20.1167 9.075 20.3 9.225C20.4833 9.375 20.6 9.56667 20.65 9.8L21.65 14.8C21.7167 15.1167 21.65 15.3957 21.45 15.637C21.25 15.879 20.9917 16 20.675 16H20.5V21C20.5 21.2833 20.404 21.5207 20.212 21.712C20.0207 21.904 19.7833 22 19.5 22C19.2167 22 18.9793 21.904 18.788 21.712C18.596 21.5207 18.5 21.2833 18.5 21V16H14.5V21C14.5 21.2833 14.4043 21.5207 14.213 21.712C14.021 21.904 13.7833 22 13.5 22H5.5ZM6.5 20H12.5V16H6.5V20ZM5.55 14H19.45H5.55ZM5.55 14H19.45L18.85 11H6.15L5.55 14Z",
    fill: "#C5C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7C4.5 6.44772 4.94772 6 5.5 6H19.5C20.0523 6 20.5 6.44772 20.5 7C20.5 7.55228 20.0523 8 19.5 8H5.5C4.94772 8 4.5 7.55228 4.5 7Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreGray);
export default __webpack_public_path__ + "static/media/storeGray.ecc403dffd9ccea9d965231295cccf42.svg";
export { ForwardRef as ReactComponent };